import React from 'react'
import { Box } from '@mui/material';
import { Routes, Route, useLocation } from "react-router-dom";
import MyToolBar from '../components/MyToolBar';
import { useSelector } from "react-redux";
import logo from './logo.png'
import logosm from './logosm.png'
import './layout.css';
import SideBar from './SideBar';

export default function Layout(props) {
    let user = useSelector((state) => state?.loginState?.auth)
    const [sidebarOpen, setSidebarOpen] = React.useState(false);
    const location = useLocation();

    let hideProps = props?.menus?.filter(item => item.to == location.pathname);
    hideProps = hideProps?.length > 0 ? hideProps[0] : {}

    const makePermittedMenu = (menu, permissions) => {
        if (menu?.owner?.includes(user.main_role)) { menu.label = menu.changeText }
        if (menu?.hide) return undefined
        if (menu?.permission && !permissions.includes(menu?.permission)) return undefined
        return menu
    }

    const createMenu = () => {
        let routers = []
        let permissions = user.permissions.map((permission) => permission.split(".")[1])
        if (props?.info) {
            console.info("Permissions", permissions)
        }
        if (!permissions.includes('*')) { permissions.push("*") }

        return [props?.menus?.map((menu, j) => {
            routers.push(menu)
            routers.push(...menu?.submenus || [])
            let pmenu = makePermittedMenu(menu, permissions)
            if (!pmenu) return undefined
            let submenus = pmenu?.submenus?.map((submenu, i) => {
                return makePermittedMenu(submenu, permissions)
            })
            pmenu.submenus = submenus?.filter((submenu) => submenu != undefined) || []
            return pmenu
        }), routers]
    }

    const [permittedMenu, routers] = createMenu()

    const closeSidebar = () => setSidebarOpen(false);
    const toggleSidebar = () => setSidebarOpen(prev => !prev);

    const Margin = (hideBar) => {
        let body = <>
            {!hideProps.hideSideBar && <SideBar
                menus={permittedMenu}
                title="WORK AXIS"
                mobileOpen={sidebarOpen}
                onClose={closeSidebar}
            />}

            {/* Mobile backdrop — clicking it closes the sidebar */}
            {sidebarOpen && !hideProps.hideSideBar && (
                <div
                    onClick={closeSidebar}
                    style={{
                        position: 'fixed', inset: 0,
                        background: 'rgba(15,23,42,0.45)',
                        backdropFilter: 'blur(2px)',
                        zIndex: 9998,
                        animation: 'fadeIn 0.2s ease both',
                    }}
                />
            )}

            <Box name="main" sx={{ width: 1, minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#f1f5f9' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                    {!hideProps.hideHeader && <>
                        <MyToolBar
                            isSubscribed={props?.isSubscribed}
                            onSubScribe={props?.onSubScribe}
                            logo={logo}
                            logosm={logosm}
                            appName={props?.appName}
                            user={user}
                            onToggled={toggleSidebar}
                            onLogout={props.onLogout}
                        />
                    </>}
                    <Box sx={{ flex: '1 1 auto', borderRadius: 0, width: '100%' }}>
                        <Routes>
                            {routers?.map((submenu, j) => submenu && <>
                                <Route key={j} path={submenu.to} element={submenu.component} />
                                {Array.isArray(submenu.proxyto)
                                    ? submenu.proxyto.map((proxyto, k) => <Route key={k} path={proxyto?.to} element={proxyto?.component} />)
                                    : <Route key={j} path={submenu?.proxyto?.to} element={submenu?.proxyto?.component} />
                                }
                            </>)}
                        </Routes>
                    </Box>
                </Box >
            </Box>
        </>

        if (hideBar) return body
        return <Box>
            <Box sx={{ flex: '0 0 auto' }}>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'stretch' }} gap={0}>
                {body}
            </Box>
        </Box >
    }

    return (
        <>
            {Margin(hideProps.hideSideBar && hideProps.hideHeader)}
        </>
    )
}